export default "__VITE_ASSET__DWBDAxCb__"